import React from 'react'
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  ITableProps,
} from 'transfix-ui/components/Table'
import { TOnHoldStops } from '../types'
import { PendingAppointmentsTableRow } from './PendingAppointmentsTableRow'

interface IPendingAppointmentsTableProps extends Omit<ITableProps, 'children'> {
  items: TOnHoldStops
}

export const PendingAppointmentsTable = ({
  items = [],
  ...props
}: IPendingAppointmentsTableProps) => {
  return (
    <Table dataTest='PendingAppointmentsTable' {...props}>
      <TableHead>
        <TableRow tableCellType='th'>
          <TableCell>#</TableCell>
          <TableCell>Shipment</TableCell>
          <TableCell>Stop</TableCell>
          <TableCell>Appointment</TableCell>
          <TableCell>Last Edited</TableCell>
          <TableCell>Last auto-request</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map(({ id, ...props }, index) => (
          <PendingAppointmentsTableRow key={id} index={index + 1} onHoldStop={{ id, ...props }} />
        ))}
      </TableBody>
    </Table>
  )
}
